import Vue from 'vue'
import Router from 'vue-router'
import AuthRoute from '@/components/Auth/router.js'
import Layout from '@/components/Layout/router.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/services/store'
import PageNotFound from '@/components/Errors/404'
import PrivacyPolicy from '@/components/PrivacyPolicy'

Vue.use(Router)

const router = new Router({
	routes: [
		...AuthRoute,
		...Layout,
		{
			path: '/privacy-policy',
			name: 'PrivacyPolicy',
			component: PrivacyPolicy
		},
		{
			path: '*',
			name: 'PageNotFound',
			component: PageNotFound
		}
	],
	mode: 'history',
	linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
	NProgress.start();
	if(to.name == "Login" && localStorage.getItem("auth_token")){
		router.push("/dashboard");
	}
	if (to.meta.permission === undefined || store.getters.getConfig("has_permissions").includes(to.meta.permission)) {
		return next()
	} else {
		if(to.name != "PageNotFound"){
			return router.push('/404');
		}
	}
	return next()
});
router.afterEach(() => {
	window.scrollTo(0,0);
	NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js